import React from "react";
import T from "prop-types";
import { EMA } from "MODULES/Receiving/constants";
import { CONSIGNMENT } from "MODULES/Orders/shared/constants";
import { CONSIGNMENT_TYPE } from "MODULES/inventories/constants";
import { CANCELLED, LINE_ITEMS } from "APP_ROOT/constants";

export const Warning = ({ label, icon, type = "danger" }) => (
  <span className={`label label-${type}`} style={{ marginLeft: "5px" }}>
    <i className={`fa fa-${icon}`} />
    &nbsp;&nbsp;{label}
  </span>
);

Warning.propTypes = {
  icon: T.string,
  label: T.string,
  type: T.string
};

export default function Warnings({ purchaseOrder }) {
  const ema = purchaseOrder
    .get(LINE_ITEMS)
    .some(l => l.get(CONSIGNMENT_TYPE) === EMA);
  const consignment = purchaseOrder
    .get(LINE_ITEMS)
    .some(l => l.get(CONSIGNMENT_TYPE) === CONSIGNMENT);

  return (
    <span>
      {purchaseOrder.get(CANCELLED) && <Warning label="Cancelled" icon="ban" />}
      {ema && (
        <Warning
          label={EMA.toUpperCase()}
          icon="location-arrow"
          type="warning"
        />
      )}
      {consignment && (
        <Warning
          label={CONSIGNMENT.toUpperCase()}
          icon="location-arrow"
          type="warning"
        />
      )}
    </span>
  );
}

Warnings.propTypes = {
  purchaseOrder: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/Warnings.jsx